import {
  CardContent,
  Card,
  Typography,
  Box,
  Button
} from "@material-ui/core";
import { useTranslation } from "react-i18next";
import React, { FC } from "react";
import moment from "moment";
import { Link } from "react-router-dom";
import Loading from "./components/Loading";
import { makeStyles } from "@material-ui/core/styles";
import ButtonLink from "../ButtonLink";
import { Fade } from "@mui/material";

const useStyles = makeStyles({
  card: {
    borderRadius: '14px'
  },
  content: {
    position: 'relative',
    padding: '13px !important',
  },
  title: {
    marginBottom: '12.11px'
  },
  data: {
    marginBottom: '13px'
  },
})

type PropsType = {
  contractData: any
}

const SubscriptionExpiring: FC<PropsType> = ({contractData}) => {
  const classes = useStyles()
  const { t } = useTranslation();
  const getDaysDiff = () => {
    let result = {
      days: 0,
      color: 'red'
    }
    if (contractData?.subscription_period) {
      const data = moment(contractData?.subscription_period)
        .diff(moment().toDate(), 'days')
      result.days = data < 0 ? 0 : data
      if (result.days > 0) {
        result.color = '#FFFFFF'
      }
    }
    return result
  }

  const data = getDaysDiff()

  return (
    <Fade in={true}>
      <Card className={classes.card}>
        <CardContent className={classes.content}>
          <Typography className={classes.title}>
            {t("statsPage_subscriptionExpiring")}
          </Typography>
          <Loading loading={!contractData} height={59}>
            <Box>
              <Typography
                className={classes.data}
                style={{color: data.color}}
                variant="h4"
              >
                {data.days} {t("statsPage_days")}
              </Typography>
              <ButtonLink
                to={'/customer-support'}
                text={t("statsPage_contactCustomerSupport")}
              />
            </Box>
          </Loading>
        </CardContent>
      </Card>
    </Fade>
  );
}
export default SubscriptionExpiring;
